import React from "react"
import { useNavigate } from "react-router-dom"

const About: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className='grid min-h-screen grid-cols-1 p-4 py-8 place-content-center bg-slate-300'>
      <h1 className='mb-8 text-4xl text-center'>Note Moko</h1>
      <div className='grid space-y-8 text-sm font-light leading-6 text-center md:p-28 md:text-lg'>
        <p>
          Experience the ultimate productivity tool with my intuitive note
          taking application.
        </p>
        <p>
          Seamlessly capture and organize your thoughts and ideas, while
          unlocking the full potential of powerful text search capabilities.
        </p>
        <p>
          My app goes beyond basic note taking, empowering you to effortlessly
          search for specific information within your notes, saving you time and
          frustration. With advanced algorithms, my app indexes your notes
          efficiently, ensuring speedy and accurate search results. Say goodbye
          to endless scrolling and hello to instant access to the information
          you need. Plus, my clean and minimalist interface provides a
          distraction-free environment for your note taking.
        </p>
        <p>
          Whether you have a vast collection or just a few notes, my application
          allows you to easily locate and retrieve them, making productivity a
          breeze. Embrace the simplicity and power of my note taking app with
          its unparalleled text search capabilities and take your productivity
          to new heights.
        </p>
        <div className='text-sm md:text-lg'>
          <p className='pt-8 text-center'>Copyright 2022</p>
          <p className='text-center'>
            Author: <span className='font-semibold'>Norvillie Villaruel</span>
          </p>
          <p className='text-center'>
            Email:{" "}
            <span className='font-semibold'>
              Norvillie.Villaruel@edu.sait.ca
            </span>
          </p>
        </div>
      </div>
      <button
        className='mt-8 text-2xl underline hover:text-slate-600'
        onClick={() => {
          navigate(-1)
        }}
      >
        Back
      </button>
    </div>
  )
}

export default About
